.trigger {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	border-radius: 6px;
	border: 1px solid #facc15;
	background: #fffbeb;
	color: #a16207;
	cursor: pointer;
	transition: all 0.15s ease;
}

.trigger:hover {
	background: #fef3c7;
}

.container {
	position: relative;
	display: inline-flex;
}

.dropdown {
	position: absolute;
	top: calc(100% + 8px);
	right: 0;
	min-width: 260px;
	max-width: 340px;
	max-height: 260px;
	overflow-y: auto;
	background: #ffffff;
	border: 1px solid #e2e8f0;
	border-radius: 10px;
	box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14);
	z-index: 100001;
	padding: 0.35rem;
}

.dropdownUp {
	top: auto;
	bottom: calc(100% + 8px);
}

.title {
	font-size: 12px;
	font-weight: 600;
	color: #475569;
	padding: 0.35rem 0.45rem;
}

.item {
	width: 100%;
	text-align: left;
	border: none;
	background: transparent;
	padding: 0.45rem;
	border-radius: 8px;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	gap: 0.1rem;
}

.item:hover {
	background: #f8fafc;
}

.itemLabel {
	font-size: 13px;
	color: #0f172a;
	font-weight: 500;
}

.itemMeta {
	font-size: 11px;
	color: #64748b;
}

.empty {
	padding: 0.45rem;
	font-size: 12px;
	color: #64748b;
}
